import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import { confirmationModalHide } from 'Global/Stores/modals'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapDispatchToProps = (dispatch, ownProps) => ({
    dispatch: action => dispatch(action),
    confirmationModalHide: () => dispatch(confirmationModalHide()),
  })

  Enhancer.displayName = 'ConfirmationModalEnhancer'

  Enhancer.propTypes = {
    confirmationModalHide: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
    onAccept: PropTypes.shape({
      meta: PropTypes.object.isRequired,
      type: PropTypes.string.isRequired,
    }).isRequired,
  }

  return connect(
    null,
    mapDispatchToProps,
  )(Enhancer)
}
